import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import api from '../../../services/api';
import history from '../../../services/history';

import { CSV, opExport } from '../../../lib/csv-core';

import ActionMenu from '../../../components/ActionMenu';
import TitleBar from '../../../components/TitleBar';
import TableHeader from '../../../components/Table/TableHeader';
import { Table, RowMaster } from '../../../components/Table';
import Pagination from '../../../components/EditorAI/Pagination';

function EmpresaParametro() {
  const location = useLocation();
  const { idEmpresa } = location.state;

  const [empresa, setEmpresa] = useState(null);
  const [parametros, setParametros] = useState([]);

  /** controle de páginas */
  const paginationRef = useRef();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);

  const carregaParametro = useCallback(() => {
    const params = Object.fromEntries(
      new URLSearchParams(location.search) || []
    );
    const { q, page } = params || [];

    const configFiltro = {
      q,
      page: Number(page),
    };

    api
      .get(`empresa/${idEmpresa}/glob-param`, {
        params: configFiltro,
      })
      .then((response) => {
        setEmpresa(response.data.empresa);
        setParametros(response.data.globParam);

        /** ajusta dados da página */
        setTotalPage(response.data.total);
        if (page > response.data.total) {
          paginationRef.current.setPage(1);
          setCurrentPage(1);
        }
      });
  }, [location, idEmpresa]);

  const handleEditar = useCallback(
    (chave) => {
      history.push(`/empresa/parametro/editar`, {
        background: location,
        idEmpresa,
        id: chave,
      });
    },
    [location, idEmpresa]
  );

  const handleVisualizar = useCallback(
    (e, chave) => {
      e.preventDefault();

      /** verifica se a linha foi clicada */
      if (e.target.nodeName.toUpperCase() === 'TD') {
        handleEditar(chave);
      }
    },
    [handleEditar]
  );

  const handleExportar = useCallback(() => {
    CSV.criarExportacao(opExport.EMPRESA_PARAMETRO, { idEmpresa });
  }, [idEmpresa]);

  useEffect(() => {
    const params = Object.fromEntries(
      new URLSearchParams(location.search) || []
    );
    const { page = 1 } = params || {};

    if (!currentPage) {
      setCurrentPage(Number(page));
      return;
    }

    Object.assign(params, { page: currentPage });

    const queryParams = Object.keys(params)
      .reduce((acc, curr) => {
        if (params[curr]) acc.push(`${curr}=${encodeURI(params[curr])}`);
        return acc;
      }, [])
      .join('&');

    if (`?${queryParams}` !== location.search) {
      history.replace(`${location.pathname}?${queryParams}`, location.state);
      return;
    }

    carregaParametro();
  }, [location, currentPage, carregaParametro]);

  return (
    <>
      <TitleBar
        back
        title={empresa ? `${empresa.descricao} / Parâmetros` : ''}
        isSearchable
        onFileDownload={handleExportar}
      />

      <Table>
        <TableHeader
          withPadding
          titles={[
            { fieldname: 'chave', title: 'Chave' },
            { fieldname: 'descricao', title: 'Descrição' },
            { fieldname: 'valor', title: 'Valor' },
            { fieldname: null, title: null },
          ]}
          cbSort={() => {}}
        />
        <tbody>
          {parametros.map((parametro) => (
            <RowMaster
              key={parametro.chave}
              onClick={(e) => handleVisualizar(e, parametro.chave)}
            >
              <td>{parametro.chave}</td>
              <td>{parametro.descricao}</td>
              <td>{parametro.valor}</td>
              <td>
                <ActionMenu onEdit={() => handleEditar(parametro.chave)} />
              </td>
            </RowMaster>
          ))}
        </tbody>
      </Table>

      <Pagination
        ref={paginationRef}
        pageCount={totalPage}
        initialData={currentPage}
        onPageChange={(page) => {
          setCurrentPage(Number(page));
        }}
      />
    </>
  );
}

export { EmpresaParametro };
